export class Shopware6ProductConfiguration {

  constructor(
    public excludeFromSalesChannels: string[] = [],
    public excludeFromExport: boolean = false
  ) {
  }
}



